{ "id": "boufbottes", "name": "Boufbottes", "slot": "bottes", "set": "bouftou", "tier": 2, "price": 100, "icon": "icons/items/boufbottes", "stats": { "vitalite": 20, "agilite": 10, "sagesse": 10 } }
